const orgPersonData = [{
    icon: 'el-icon-house',
    name: '我的群组',
    path: '/persnnel/mygroup',
    children: []
    }]

export default orgPersonData;